import { FC, useEffect } from "react";
import ViteEnv from "@/details/env/vite/ViteEnv";
import { useAppStore } from "core/stores";
import BrowserNavigator from "@/details/navigation/browser/browserNavigator/BrowserNavigator";

const AppZustandProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // Initialize stores
  const { initializeLogger, setNavigator } = useAppStore();

  useEffect(() => {
    // Initialize logger
    initializeLogger(new ViteEnv());

    // Set navigator with working navigation function using window.location.hash
    const navigateFunction = (path: string) => {
      window.location.hash = `#/${path}`;
    };
    setNavigator(new BrowserNavigator(navigateFunction));
  }, [initializeLogger, setNavigator]);

  // No need for context provider - Zustand handles state management
  return <>{children}</>;
};

export default AppZustandProvider;
